export const RADIAN = Math.PI / 180;

export const OCCUPANCY_PIE_COLORS = ["#5D6293", "#00B48D", "#F5F5FC"];

export const REVENUE_PIE_COLORS = ["#00B48D", "#5D6293", "#02094F", "#B4B7CF"];
